var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <a class=\"link\" href=\""
    + alias2(__default(require("../handlebars-helpers/i18n.js")).call(alias1,"url:policies",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":28},"end":{"line":1,"column":51}}}))
    + "\" target=\"_blank\">"
    + alias2(__default(require("../handlebars-helpers/i18n.js")).call(alias1,"common:privacy-and-terms",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":104}}}))
    + "</a> | <a class=\"link\" href=\"https://status.netop.com/\" target=\"_blank\">"
    + alias2(__default(require("../handlebars-helpers/i18n.js")).call(alias1,"common:system-status",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":176},"end":{"line":1,"column":207}}}))
    + " </a>| "
    + alias2(container.lambda((depth0 != null ? lookupProperty(depth0,"copyright") : depth0), depth0))
    + "\n";
},"useData":true});